export enum DateFormates {
  defaultDate = 'dd.MM.yyyy',
  inputDate = "EEE MMM dd yyyy HH:mm:ss 'GMT'xxx",
  dateWithHours = 'dd.MM.yyyy HH:mm:ss',
}
